import Slugger from 'github-slugger'

import { visit } from 'unist-util-visit'
import { hasProperty } from 'hast-util-has-property'
import { headingRank } from 'hast-util-heading-rank'
import { toString } from 'hast-util-to-string'

/**
 * Modified version of rehype-slug to allow us to set a 'global' slugger instance
 * @param {*} slugger The slugger to use.
 */
export const slug = ({ slugger = new Slugger() } = {}) => {
  return (tree) => {
    visit(tree, 'element', (node) => {
      if (headingRank(node) && !hasProperty(node, 'id')) {
        node.properties.id = slugger.slug(toString(node))
      }
    })
  }
}

export { Slugger }
